import React from 'react';
import PropTypes from 'prop-types';

import { Check } from 'components/icons';
import styles from 'styles/components/reviews/addReviewConfirmation.scss';

const AddReviewConfirmation = (undefined, { testId }) => (
  <div className={styles.reviewFormSuccess}>
    <h3>Thanks for writing a review!</h3>
    <div className={styles.mobileMessage}>
      <span className={styles.successIcon}>
        <Check size={18}/>
      </span>
      <p data-test-id={testId('successfulReviewMobile')}>Thanks for your review! Check back here in a few days to see it posted.</p>
    </div>
    <div className={styles.desktopMessage}>
      <p data-test-id={testId('successfulReviewDesktop')}>Our team loves reading customer reviews, so they're looking forward to giving yours a look-see. It should be posted within 5 business days, so check back here to see it posted!</p>
    </div>
  </div>
);

AddReviewConfirmation.contextTypes = {
  testId:PropTypes.func
};

export default AddReviewConfirmation;
